/**
 * @Description:
 * @Version: 2.5.2
 * @Autor: jzt
 * @Date: 2023-03-15 10:00:00
 * @LastEditors: jzt
 * @LastEditTime: 2023-03-29 17:30:00
 */
import Vue from "vue";
import axios from "axios";
import { Message, Loading } from "element-ui";
// 响应时间
// axios.defaults.timeout = 5 * 1000
// 配置cookie
// axios.defaults.withCredentials = true
// 配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 静态资源
Vue.prototype.$static = "";

// 配置接口地址
// axios.defaults.baseURL = 'http://18.180.0.119:8880';   // 本地环境
// axios.defaults.baseURL = 'https://api.aohoo.cn';       // 测试环境
// axios.defaults.baseURL = 'https://api.gpuez.com';      // 线上环境
axios.defaults.baseURL = process.env.VUE_APP_INTERFACE_URL;

var loadingInstance;
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.data = config.data;
    }
    config.headers = {...config.headers, "Client-Version": process.env.CLIENT_VERSION}
    // const separator = config.url.includes('?') ? '&' : '?';
    // const nonce = crypto.randomUUID();
    // config.url += `${separator}nonce=${nonce}`;
    return config;
  },
  err => {
    // loadingInstance.close()
    Message.error("请求错误");
    return Promise.reject(err);
  }
);
/**
 *  @Description: 返回状态判断(添加响应拦截器)
 *  @Description: 无特殊情况或无其它渠道 勿轻易修改
 *  @Autor: jzt
 *  @LastEditTime: 2024-02-26 17:30:00
 */
axios.interceptors.response.use(
  res => {
    if (res.data.code == 200) {
      return res.data;
    } else if (res.data.code==401||res.data.code==402) {
      // localStorage.clear();
      localStorage.removeItem('token')
      localStorage.removeItem('oneClick')
      localStorage.removeItem('userInfo')
      if(location.pathname!='/' && location.pathname.indexOf("/zscloud")==-1) {
        Message.error("登录超时，请重新登录");
        setTimeout(() => location.href = "/login", 300);
      }
    } else {
      Message.error(res.data.msg);
    }
    return res.data;
  },
  err => {
    if(err.response.status==401) {
      localStorage.removeItem('token')
      localStorage.removeItem('oneClick')
      localStorage.removeItem('userInfo')
    } else {
      Message.error(err.response.status+" ：网络或服务异常，请稍后重试");
    }
    return Promise.reject(err.response);
  }
);

// 发送请求 Get
export function get(url,params) {
  return new Promise((resolve, reject) => {
    params ? url = url+'?'+params : url;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token")
        }
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 发送请求 Post
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded;",
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token")
        }
      })
      .then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}
// 发送请求 Delete
export function del(url) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token")
        }
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 发送请求 Put
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token")
        }
      })
      .then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}
// 文件postFile请求
export function postFile(url, params, headers) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, headers)
      .then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/axiosconfig.js